import { render, staticRenderFns } from "./ForgotPwdForm.vue?vue&type=template&id=09eb1a74&scoped=true"
import script from "./ForgotPwdForm.vue?vue&type=script&lang=js"
export * from "./ForgotPwdForm.vue?vue&type=script&lang=js"
import style0 from "./ForgotPwdForm.vue?vue&type=style&index=0&id=09eb1a74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09eb1a74",
  null
  
)

export default component.exports